module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAACXBIWXMAABcRAAAXEQHKJvM/AAAAlUlEQVRYw2P8//8/g8WOjP8MZIATHjMY0cV2HzlFllmuNmaMjObb08nSjM1B5DoEBpgYBhEYdcyoY0YdQy3AQk3DXG3MGEejaTTNkAKcF90arZtGHTOCHYOt6UhJs5MSwPj////RrD00SmBKWvWU1tQoIUNp94JS/aNpZtQxo44ZdczIdQylxTmy/r1xamSbtTdOjREASzgtkzcrDigAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icons/01.png
// module id = /zjB
// module chunks = 2